


/* eslint no-underscore-dangle: 0 */

import React, { useEffect, useState } from "react";
import { Input, Button, Row, Col, Container, Card, CardBody, Alert, Spinner, Label } from "reactstrap";
import {  Navigate, useNavigate, useParams } from "react-router-dom";
import { connect } from "react-redux";

const mapStateToProps = (state) => ({
  isAuth: state.Login.isAuth,
})
const ResetPassword = (props) => {

  const [codes, setCode] = useState("");
  const [formReset, resetPasswordForm] = useState({});
  const params = useParams();
  const [alertColor, setAlertColor] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    setCode(params.code);
  }, []);
const navigate=useNavigate()


  const validateOnChange = (event) => {
    const { name, value } = event.target;
    resetPasswordForm({ ...formReset, [name]: value });
  };

  const showAlert = (message, color) => {
    setAlertColor(color);
    setErrorMessage(message);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const apiUrl = window.__ENV && window.__ENV.apiUrl;

    // eslint-disable-next-line
    const email = formReset.email;
    const code = codes;
    // eslint-disable-next-line
    const password = formReset.password;// eslint-disable-next-line
    const confirmPassword = formReset.confirmPassword;// eslint-disable-next-line

    try {
      setLoading(true);
      const emailResponse = await fetch(`${apiUrl}/api/user/resetpassword`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: email, code: code, password: password, confirmPassword: confirmPassword }),
      });

      const data = await emailResponse.text();
  


      if (emailResponse.ok) {
        showAlert("Email sent", "success");
        setLoading(false);
        navigate("/apps/invoices")
        
      } else {
        showAlert(data, "danger");
        setLoading(false);
      }
    } catch (error) {
     
      showAlert("An error occurred", "danger");
      setLoading(false);
    }
  };

  

  return props.isAuth ? (<Navigate to ="/auth/loginform"/>):(
    <div className="page-content">
      <>
        <div className="bg-pattern" style={{ height: "100vh" }}>
          <div className="bg-overlay"></div>
          <div className="account-pages pt-5">
            <Container>
              <Row className="justify-content-center">
                <Col lg={6} md={8} xl={4}>
                  <Card className="mt-5">
                    <CardBody className="p-4">
                      <div className="">
                        <div className="text-center"></div>
                        {errorMessage && <Alert color={alertColor}>{errorMessage}</Alert>}
                        <h4 className="font-size-18 text-muted mt-2 text-center">Enter New Password</h4>
                        <form className="form-horizontal" action="#">
                          <Row>
                            <Col md={12}>
                              <div className="mt-4">
                              <Label>Email</Label>
                                <Input
                                  type="email"
                                  name="email"
                                  className="border-right-0"
                                  placeholder="Enter email address"
                                  onChange={validateOnChange}
                                />
                              </div>
                              <div className="mt-4">
                              <Label htmlFor="email">Password</Label>
                                <Input
                                  type="password"
                                  id="id-password"
                                  name="password"
                                  className="border-right-0"
                                  placeholder="Password"
                                  onChange={validateOnChange}
                                />
                              </div>
                              <div className="mt-4">
                              <Label>Confirm Password</Label>
                                <Input
                                  type="password"
                                  id="id-confirmpassword"
                                  name="confirmPassword"
                                  className="border-right-0"
                                  placeholder="Confirm password"
                                  onChange={validateOnChange}
                                />
                              </div>
                              <div className="d-grid mt-4">
                                <Button color="dark" onClick={onSubmit} disabled={isLoading}>
                                  {isLoading ? (
                                    <>
                                      <Spinner size="sm" color="light" /> Loading...
                                    </>
                                  ) : (
                                    "Submit"
                                  )}
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        </form>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </>
    </div>
  );
};

export default connect(mapStateToProps,null)(ResetPassword);
